// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';
const basePath = '/api';

export const getRgaUnits = async () => {

    const endPoint = `${basePath}/rga-units`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

};

export const getRgaStatus = async () => {

    const endPoint = `${basePath}/rga-status`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

};



// WEBPACK FOOTER //
// ./src/rga/shared/services/fetch-service-rga.js